<template>
    <div class="w-full max-w-[18rem] h-auto bg-white border border-gray-200 rounded-lg shadow py-2 pb-4" :class="{'animate animate-bouncing':tag.id == 0}">
        <div class="flex justify-end px-4" v-if="tag.id > 0">
            <button :id="'dropdownButton-'+tag.id" :data-dropdown-toggle="'dropdown-'+tag.id" class="inline-block text-gray-500 hover:bg-gray-100 focus:ring-4 focus:outline-none focus:ring-gray-200 rounded-lg text-sm p-1.5" type="button">
                <span class="sr-only">{{ $t("admin.auto.open_dropdown") }}</span>
                <svg class="w-5 h-5" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 16 3">
                    <path d="M2 0a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Zm6.041 0a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3ZM14 0a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Z"/>
                </svg>
            </button>
            <!-- Dropdown menu -->
            <div :id="'dropdown-'+tag.id" class="z-10 hidden text-base list-none bg-white divide-y divide-gray-100 rounded-lg shadow w-44">
                <ul class="py-2" :aria-labelledby="'dropdownButton-'+tag.id">
                <li>
                    <button 
                    type="button"
                    data-modal-target="form-tag-modal" 
                    data-modal-toggle="form-tag-modal" 
                    class="w-full block px-4 py-2 text-sm text-left text-gray-700 hover:bg-gray-100"
                    @click="handleTag(tag)"
                    >{{ $t("admin.auto.editar") }}</button>
                </li>
                <li>
                    <button 
                    type="button" 
                    class="w-full block px-4 py-2 text-sm text-left text-red-600 hover:bg-gray-100"
                    @click="deleteTag()">{{ $t("admin.auto.eliminar") }}</button>
                </li>
                </ul>
            </div>
        </div>
        <div class="flex flex-col items-center">
            <div class="flex flex-col relative items-center gap-2"  v-if="tag.id == 0 | tag_id > 0">
                <textarea
                type="text" 
                class="rounded-lg border-eblack-300 text-sm py-1"
                rows="1"
                v-model="inputTag.name">
                </textarea>
                <div class="w-full flex gap-1 items-center justify-center">
                    <button
                    type="button"
                    class="border border-egreen-500 rounded-full px-2 py-0.5 text-xs"
                    v-if="inputTag.name != ''"
                    @click="submit()"
                    >
                        <span class="text-egreen-900">{{ $t("admin.auto.guardar") }}</span>
                    </button>
                    <button
                    type="button"
                    class="border border-eblack-500 rounded-full px-2 py-0.5 text-xs"
                    @click="cancelAdding()"
                    >
                     <span class="text-eblack-900">{{ $t("admin.auto.cancelar") }}</span>
                    </button>
                </div>
            </div>
            <h5 class="mb-1 text-md font-medium text-eblack-900 text-center" v-if="tag.id > 0 &&  tag_id  == 0">{{ tag.name }}</h5>
        </div>
    </div>

</template>

<script>
import { i18n } from "@/i18n";
    import tagsRequests from "@/services/admin/tags-service";
    import { initFlowbite } from 'flowbite';
    import { useToast } from "vue-toastification";

    export default {
        props:["tag","setTag","initData","deleteAdding"],
        name:"CardDropdown",
        data(){
            return {
                tag_id:0,
                inputTag:{
                    name:"",
                    slug:""
                },
                toast:useToast()
            }
        },
        methods:{
            handleTag(tag){
                this.tag_id = tag.id
                this.inputTag.name = tag.name
            },
            deleteTag(){
                tagsRequests.deleteTag(this.tag.id)
                .then(
                    res => {
                        if(res.status == 200){
                            this.initData()
                            this.toast.success(i18n.global.t("admin.auto.tag_eliminada"), {
                                timeout: 3000,
                                position: "top-right"
                            });
                        }
                    }
                )
                .catch(error => {
                    let response = error.response
                    if(response){
                        let { data } = response
                        let message = data.message
                        this.errors = message
                    }
                })
            },
            cancelAdding(){
                this.deleteAdding()
            },
            submit(){
                this.prepareSlug();
                if(this.tag_id  > 0){
                    this.update();
                }else{
                    this.save()
                }
            },
            save(){
                tagsRequests.saveTag(this.inputTag)
                .then(
                    res=>{
                        if(res.status == 201){
                            this.resetForm()
                            this.initData()
                            this.toast.success(i18n.global.t("admin.auto.tag_guardada"), {
                                timeout: 3000,
                                position: "top-right"
                            });
                        }
                    }
                )
                .catch(
                    error => {
                        let response = error.response
                        if(response){
                            let { data } = response
                            let message = data.message
                            this.errors = message
                            console.log(message)
                        }
                    }
                )
            },
            update(){
                tagsRequests.updateTag(this.tag_id, this.inputTag)
                .then(
                    res => {
                        if(res.status == 200){
                            this.resetForm()
                            this.initData()
                            this.toast.success(i18n.global.t("admin.auto.tag_actualizada"), {
                                timeout: 3000,
                                position: "top-right"
                            });
                        }
                    }
                )
                .catch(error => {
                    let response = error.response
                    if(response){
                        let { data } = response
                        let message = data.message
                        this.errors = message
                    }
                })
            },
            resetForm(){
                this.tag_id = 0
                this.inputTag = {
                    name:"",
                    slug:""
                }
            },
            prepareSlug(){
                let slug = this.inputTag.name
                .toLowerCase() // Convertir a minúsculas
                .normalize("NFD") // Normalizar caracteres con acentos
                .replace(/[\u0300-\u036f]/g, "") // Eliminar los acentos
                .replace(/\s+/g, "_") // Reemplazar espacios por guiones bajos
                .replace(/[^\w_]+/g, ""); // Eliminar caracteres no alfanuméricos.
       
                this.inputTag.slug = slug;
            },
            resetData(){
                this.tag_id = 0
                this.resetForm()
            }
        },
        mounted(){
            initFlowbite()
        }
    }
</script>

<style lang="scss" scoped>

</style>